import './App.css';
import { AllRoutes } from './components/Routes/Allroutes';

function App() {
  return (
    <div>
      <AllRoutes />
    </div>
  );
}

export default App;
